<template>
  <div class="m-0 pt-2 pb-1 px-3">
    <div class="d-flex flex-wrap justify-content-between">
      <div class="d-inline-block nowrap mt-2 mb-1" style="">
        <a v-if="sidebarToggleVisible && !showingContactSales" class="btn-sm p-0 clickable mr-3" @click="$emit('sidebar-toggle')">
          <i
            v-if="sidebarVisible"
            :style="`font-size: 18px;color:${theme.page_toolbar_button_color};border:${theme.page_toolbar_button_color} 1px solid;`"
            class="fa fas fa-outdent py-1 px-2 rounded"
          />
          <i
            v-if="!sidebarVisible"
            :style="`font-size: 18px;color:${theme.page_toolbar_button_color};border:${theme.page_toolbar_button_color} 1px solid;`"
            class="fa fas fa-indent py-1 px-2 rounded"
          />
        </a>
        <h5
          :style="`position: relative;  top: 1px; color:${
            theme && theme.page_toolbar_text_color ? theme.page_toolbar_text_color : theme.page_toolbar_text_color
          }; font-family:${theme.page_toolbar_title_font ? theme.page_toolbar_title_font : 'inherit'}`"
          class="m-0 ml-1 d-inline-block"
        >
          <span v-if="!theme.page_toolbar_custom_title">{{ company.name }}</span>
          <span v-if="theme.page_toolbar_custom_title">{{ theme.page_toolbar_custom_title }}</span>
        </h5>
      </div>
      <!-- <div class="col-12 col-md-4">
    <div
      v-if="!showingContactSales"
      :style="`transition:none;${
        !isTableView && theme.page_toolbar_sort_by_visible
          ? 'visibility:visible;opacity:1'
          : 'visibility:hidden;opacity:0'
      }`"
    >
      <BushelSelect
        class="p-0 m-0"
        style="position: relative; top: 2.5px; hieght: 28px;"
        :options="sortByOptions"
        :allow-empty="true"
        placeholder="Sort By"
        label-class="d-none m-0 p-0"
        no-padding
        :value="selectedSortBy"
        :show-select-labels="false"
        track-by="id"
        label="name"
        @select="sortBy"
      />
    </div>
  </div> -->
      <div class="d-inline-block">
        <div class="my-1">
          <div class="nowrap text-center">
            <div v-if="!showingContactSales && !isTableView && theme.page_toolbar_sort_by_visible" class="d-inline-block">
              <BushelSelect
                class="p-0 m-0"
                style="position: relative; top: 2.5px; height: 28px"
                :options="sortByOptions"
                :allow-empty="true"
                placeholder="Sort By"
                label-class="d-none m-0 p-0"
                no-padding
                :value="selectedSortBy"
                :show-select-labels="false"
                track-by="id"
                label="name"
                @select="sortBy"
              />
            </div>
            <div
              v-if="pricingTierDiscounts && pricingTierDiscounts.id && theme.page_toolbar_user_discount_visible && !showingContactSales"
              class="ml-2 clickable d-inline-block"
              @click="$emit('show-price-tier-discounts-modal', true)"
            >
              <UserDiscountIcon
                :fill="theme.page_toolbar_button_color"
                :svg-style="{
                  top: '3px',
                  position: 'relative',
                  height: '28px',
                  width: '28px',
                }"
              />
            </div>
            <div
              v-if="bulkDiscounts && bulkDiscounts.length > 0 && theme.page_toolbar_user_discount_visible && !showingContactSales"
              class="ml-1 clickable d-inline-block"
              :class="pricingTierDiscounts ? 'ml-1' : ''"
              @click="$emit('show-bulk-discounts-modal', true)"
            >
              <DiscountIcon
                :fill="theme.page_toolbar_button_color"
                :svg-style="{
                  top: '3px',
                  position: 'relative',
                  height: '28px',
                  width: '28px',
                }"
              />
            </div>
            <div
              v-if="!hideShoppingActions && !showingContactSales"
              class="clickable d-inline-block"
              @click="$emit('show-company-display-page', true)"
            >
              <SearchLocationIcon
                id="SearchLocationIcon"
                :fill-one="theme.page_toolbar_button_color"
                :fill-two="theme.page_toolbar_button_color"
                :svg-style="{
                  top: '3px',
                  position: 'relative',
                  height: '28px',
                  width: '28px',
                }"
              />
            </div>
            <div v-if="theme.page_toolbar_grid_table_switch_visible && !showingContactSales" class="d-inline-block pl-2" :class="toggleClasses">
              <b-button-group :class="`mt-1`">
                <BushelBtn
                  ref="toolbarGridSwitch"
                  variant=""
                  :style="toolbarGridSwitchStyle"
                  :outline="layout !== 'grid'"
                  @click="$emit('layout-toggle-grid')"
                >
                  Grid
                </BushelBtn>
                <BushelBtn
                  ref="toolbarTableSwitch"
                  variant=""
                  :style="toolbarTableSwitchStyle"
                  :outline="layout !== 'table'"
                  @click="$emit('layout-toggle-table')"
                >
                  Table
                </BushelBtn>
              </b-button-group>
            </div>
            <div v-if="!showingContactSales && showContactSalesBtn && !isTheSeller" class="ml-2">
              <BushelBtn
                class="mt-1 p-0 px-2"
                :style="`height: 32px; border-color: ${theme && theme.page_toolbar_button_color} !important; color: ${
                  theme && theme.page_toolbar_button_color
                } !important`"
                outline
                @click="$emit('show-contact-sales', true)"
              >
                <i class="fas fa-envelope" /> Contact Sales
              </BushelBtn>
            </div>
            <div v-if="showingContactSales" class="ml-auto">
              <BushelBtn
                class="mt-1 p-0 px-2"
                :style="`height: 32px; border-color: ${theme && theme.page_toolbar_button_color} !important; color: ${
                  theme && theme.page_toolbar_button_color
                } !important`"
                outline
                @click="$emit('hide-contact-sales', true)"
              >
                <i class="fas fa-angle-left" /> Back to menu
              </BushelBtn>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DiscountIcon from "@/components/common/icons/DiscountIcon.vue";
import SearchLocationIcon from "@/components/common/icons/SearchLocationIcon.vue";
import UserDiscountIcon from "@/components/common/icons/UserDiscountIcon.vue";

export default {
  name: "StoreFrontToolbar",
  components: {
    DiscountIcon,
    SearchLocationIcon,
    UserDiscountIcon,
  },
  props: {
    theme: { type: Object, required: true },
    company: { type: Object, required: true },
    pricingTierDiscounts: { type: Object },
    bulkDiscounts: { type: Array },
    hideShoppingActions: { type: Boolean, default: false },
    sidebarToggleVisible: { type: Boolean, default: false },
    sidebarVisible: { type: Boolean, default: false },
    isTableView: { type: Boolean, default: false },
    showingContactSales: { type: Boolean, default: false },
    showContactSalesBtn: { type: Boolean, default: false },
    hidePrices: { type: Boolean, default: false },
    layout: { type: String, required: true },
    selectedSort: { type: Object },
    isTheSeller: { type: Boolean },
  },
  emits: [
    "sidebar-toggle",
    "layout-toggle-grid",
    "layout-toggle-table",
    "show-price-tier-discounts-modal",
    "show-bulk-discounts-modal",
    "show-company-display-page",
    "show-contact-sales",
    "hide-contact-sales",
    "sort-by",
  ],
  data() {
    return {
      sortByOptions: !this.hidePrices
        ? [
            { id: 1, name: "Name" },
            { id: 2, name: "Price Low" },
            { id: 3, name: "Price High" },
            { id: 4, name: "Category" },
            { id: 5, name: "Brand" },
            { id: 6, name: "Strain" },
          ]
        : [
            { id: 1, name: "Name" },
            { id: 4, name: "Category" },
            { id: 5, name: "Brand" },
            { id: 6, name: "Strain" },
          ],
      selectedSortBy: this.selectedSort ? this.selectedSort : null,
      tooltipKey: 1,
      showToolTip: false,
    };
  },
  computed: {
    toggleClasses() {
      let classes = "";

      if (!this.theme.page_toolbar_sort_by_visible && this.bulkDiscounts && this.bulkDiscounts.length == 0 && !this.pricingTierDiscounts) {
        classes = "ml-auto";
      } else if (this.theme.page_toolbar_sort_by_visible && this.bulkDiscounts && this.bulkDiscounts.length == 0 && !this.pricingTierDiscounts) {
        classes = "ml-auto ml-md-3";
      } else {
        classes = "ml-3";
      }

      return classes;
    },
    toolbarGridSwitchStyle() {
      const gridStyle = {
        backgroundColor: this.layout == "grid" ? this.theme.page_toolbar_button_color : "transparent",
        borderColor: this.theme.page_toolbar_button_color,
        color: this.layout == "grid" ? this.theme.page_toolbar_button_text_color : this.theme.page_toolbar_button_color,
        height: "32px",
        padding: "0 .5rem",
      };

      return gridStyle;
    },

    toolbarTableSwitchStyle() {
      const tableStyle = {
        backgroundColor: this.layout == "table" ? this.theme.page_toolbar_button_color : "transparent",
        borderColor: this.theme.page_toolbar_button_color,
        color: this.layout == "table" ? this.theme.page_toolbar_button_text_color : this.theme.page_toolbar_button_color,
        height: "32px",
        padding: "0 .5rem",
      };

      return tableStyle;
    },
  },
  methods: {
    sortBy(selected) {
      this.selectedSortBy = selected;
      this.$emit("sort-by", selected);
    },
    getBackgroundColor(element) {
      return window.getComputedStyle(element).backgroundColor;
    },
    rgbToLuminance(r, g, b) {
      // Convert RGB values to luminance
      const a = [r, g, b].map((v) => {
        const n = v / 255;
        return n <= 0.03928 ? n / 12.92 : ((n + 0.055) / 1.055) ** 2.4;
      });

      return a[0] * 0.2126 + a[1] * 0.7152 + a[2] * 0.0722;
    },
    isColorLight(color) {
      // Extract RGB values from color string
      const rgb = color.match(/\d+/g);
      const r = parseInt(rgb[0], 10);
      const g = parseInt(rgb[1], 10);
      const b = parseInt(rgb[2], 10);

      // Calculate luminance
      const luminance = this.rgbToLuminance(r, g, b);
      return luminance > 0.5; // Threshold for light or dark
    },
    checkBackgroundColor(reference) {
      const element = reference;
      if (element) {
        const backgroundColor = this.getBackgroundColor(element);
        const isLight = this.isColorLight(backgroundColor);
      }
    },
  },
};
</script>

<style scoped>
/*
Chris commented this out. I'm not sure what the purpose of this is supposed to be
but it looks bad and causes the background to jump when selected.
.store .multiselect {
    min-height: 20px !important;
}

.store .multiselect__select {
    height: 30px !important;
}

.store .multiselect__tags {
    min-height: 20px !important;
    padding: 5px 40px 0 8px !important;
} */
</style>
